import React from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";
import { ReactComponent as Members } from "../../assets/users.svg";
import { ReactComponent as BusinessFiles } from "../../assets/files.svg";
import { ReactComponent as LinkATO } from "../../assets/link.svg";
import { ReactComponent as EditDetails } from "../../assets/pencil.svg";

const getTabIcon = (group, isSelected, isDarkMode, theme) => {
  const iconStyle = {
    marginRight: "8px",
    width: "24px",
    height: "24px",
    stroke: isSelected
      ? theme.palette.primary.main
      : isDarkMode
      ? "#E8E8E8"
      : "#252525",
  };

  switch (group) {
    case "Members":
      return <Members style={iconStyle} />;
    case "Business Files":
      return <BusinessFiles style={iconStyle} />;
    case "Link Subscriber to ATO":
      return <LinkATO style={iconStyle} />;
    case "Details":
      return <EditDetails style={iconStyle} />;
    default:
      return <span style={iconStyle}>•</span>;
  }
};

const borderExpand = {
  "@keyframes expand": {
    "0%": { width: "0%", left: "50%" },
    "100%": { width: "100%", left: "0%" },
  },
};

const CustomTabs = ({ selectedTab, handleTabChange, orientation = "horizontal" }) => {
  const availableGroups = [
    "Details",
    "Members",
    "Business Files",
    "Link Subscriber to ATO",
  ];
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);

  const isVertical = orientation === "vertical";

  return (
    <Tabs
      value={selectedTab}
      onChange={handleTabChange}
      aria-label="report tabs"
      orientation={isVertical ? "vertical" : "horizontal"}
      variant={isVertical ? "standard" : "scrollable"}
      scrollButtons={false}
      TabIndicatorProps={
        isVertical
          ? {
              sx: {
                left: 0,
                width: 3,
              },
            }
          : {
              style: {
                backgroundColor: "transparent",
              },
            }
      }
      sx={
        isVertical
          ? {
              borderRight: 1,
              borderColor: "divider",
              minWidth: 220,
              alignItems: "stretch",
            }
          : undefined
      }
    >
      {availableGroups.map((group, index) => {
        const isSelected = selectedTab === index;

        return (
          <Tab
            disableRipple
            key={group}
            value={index}
            label={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  py: 1,
                  position: "relative",
                  ...(!isVertical
                    ? {
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          bottom: 0,
                          left: "50%",
                          width: "0%",
                          height: "2px",
                          backgroundColor: isSelected
                            ? theme.palette.primary.main
                            : "transparent",
                          animation: isSelected ? "expand 0.4s forwards" : "none",
                        },
                        ...borderExpand,
                      }
                    : {}),
                }}
              >
                {getTabIcon(group, isSelected, isDarkMode, theme)}
                <Typography
                  sx={{
                    color: isSelected
                      ? theme.palette.primary.main
                      : theme.palette.blackWhite.main,
                    fontSize: {
                      xs: "18px",
                      sm: "20px",
                      md: "24px",
                    },
                    fontWeight: "400",
                    leadingTrim: "both",
                    textEdge: "cap",
                    textAlign: isVertical ? "left" : "inherit",
                  }}
                >
                  {group}
                </Typography>
              </Box>
            }
            sx={{
              minWidth: isVertical ? "100%" : "auto",
              alignItems: isVertical ? "flex-start" : "center",
              padding: {
                xs: "8px 16px",
                sm: "10px 20px",
                md: "12px 24px",
              },
              textTransform: "none",
            }}
          />
        );
      })}
    </Tabs>
  );
};

export default CustomTabs;
